/**
 * A moment a person STATES on a report's page — Phase 10c.
 *
 * A delivery's `deliveredAt` is what the recorder says happened, read off a
 * clock in the room. Reading that clock is `DateTimeField`'s job: it hands back
 * an instant written with the LABORATORY's offset (its settings' timezone,
 * never the browser's — UX follow-up, `PROJECT_DOCUMENTATION.md` 15.26), for
 * example `2026-09-14T09:30:00+03:00`. This module used to convert with the
 * browser's own offset; that conversion is gone, so a laptop set to another
 * zone can no longer move a delivery.
 *
 * Nothing here decides whether the moment is acceptable: the API refuses a
 * `deliveredAt` more than five minutes ahead of its own clock (D81). The page
 * checks the same limit first only so a mistyped year is said at once.
 */

/** The API refuses a stated delivery time more than this far ahead of its clock (D81). */
export const DELIVERED_AT_MAX_AHEAD_MINUTES = 5;

/** True when the instant is further ahead of `now` than the API accepts. */
export function isTooFarAhead(iso: string, now: number = Date.now()): boolean {
  const at = new Date(iso).getTime();
  return Number.isFinite(at) && at - now > DELIVERED_AT_MAX_AHEAD_MINUTES * 60_000;
}
